"use client"

import {
  IonAccordion,
  IonAccordionGroup,
  IonContent,
  IonIcon,
  IonItem,
  IonList,
  IonMenu,
  IonMenuToggle,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonButton,
} from "@ionic/react"
import { useHistory, useLocation } from "react-router-dom"
import {
  homeSharp,
  personCircle,
  returnDownForward,
  notificationsOutline,
  businessOutline,
  exitOutline,
  menuOutline,
} from "ionicons/icons"
import "./Menu.css"
import { getUser, getBusinessData, removeUserSession } from "../common/utils"
import type React from "react"
import { useEffect, useState } from "react"
import { Button, Box, Typography, Avatar } from "@mui/material"
import { useBusinessContext } from "../context/business-context"

interface AppPage {
  url: string
  iosIcon: string
  mdIcon: string
  name: string
  moduleID: string
}

interface SubModuleList {
  id: string
  url: string
  iosIcon: string
  mdIcon: string
  name: string
  moduleID: string
  submoduleID: number
}

let menuList = []
let menuListx = []
menuListx = getUser()?.menuList
let subModule = []
subModule = getUser()?.submoduleList

const labels = ["Family", "Friends", "Notes", "Work", "Travel", "Reminders"]

// Main Menu Component
const Menu: React.FC = () => {
  const {
    selectedBusinessId,
    setSelectedBusinessId,
    selectedBusinessTypeId,
    setSelectedBusinessTypeId,
    selectedBusinessName,
    setSelectedBusinessName,
    selectedBusinessTypeName,
    setSelectedBusinessTypeName,
    selectedRoleID,
    setSelectedRoleID,
    selectedRoleName,
    selectedBusiness,
    setSelectedBusiness,
  } = useBusinessContext()

  const businessData = getBusinessData()
  const location = useLocation()
  const history = useHistory()

  // Check if a menu item is active
  const isMenuActive = (menu: AppPage) => {
    return subModule.some(
      (sub) =>
        sub.moduleID === menu.moduleID &&
        location.pathname.includes(sub.url)
    )
  }

  // Check if a submenu item is active
  const isSubMenuActive = (subMenu: SubModuleList) => {
    return location.pathname.includes(subMenu.url)
  }

  // Get active menu item for accordion expansion
  const getActiveMenuValue = () => {
    const activeMenu = menuList?.find(menu =>
      subModule.some(sub =>
        sub.moduleID === menu.moduleID &&
        location.pathname.includes(sub.url)
      )
    )
    return activeMenu?.name || ""
  }

  if (businessData?.name === "undefined" || businessData?.business_id === "undefined") {
    ; () => hangleLogout()
  }

  useEffect(() => {
    setSelectedBusiness(businessData)
  }, [])

  menuList = menuListx?.filter(
    (menu) =>
      Number(menu.business_type_id) === Number(businessData.business_type_id) &&
      Number(menu.roleID) === Number(businessData.roleID),
  )

  function hangleLogout() {
    removeUserSession()
    history.replace("/login")
    window.location.replace("/login")
  }

  const [enabled, setEnabled] = useState(false)

  const handleEnable = () => {
    const audio = new Audio("login/sounds/notification.mp3")
    audio
      .play()
      .then(() => {
        setEnabled(true)
        console.log("Notification sound enabled.")
      })
      .catch((error) => {
        console.warn("Sound unlock failed:", error)
      })
  }

  const handleEnableNotifications = () => {
    if (!("Notification" in window)) {
      alert("This browser does not support desktop notifications.")
      return
    }
    Notification.requestPermission().then((permission) => {
      if (permission === "granted") {
        handleEnable()
        new Notification("Notifications enabled", {
          body: "You'll now get updates.",
        })
      } else {
        alert("Notifications not enabled.")
      }
    })
  }

  const [room, setRoom] = useState("room12345")
  const [message, setMessage] = useState("")
  const [chat, setChat] = useState([])

  useEffect(() => {
    const user = getUser()?.userData
  }, [room])

  const iconColors = [
    "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
    "linear-gradient(135deg, #f59e0b 0%, #f97316 100%)",
    "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
    "linear-gradient(135deg, #10b981 0%, #059669 100%)",
    "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
  ];

  // Business type configurations
  const getBusinessConfig = (businessTypeId: number) => {
    const configs = {
      1001: {
        title: "Coop Menu Dashboard",
        color: "secondary",
        gradient: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
      },
      1002: {
        title: "Ajo Menu Dashboard",
        color: "warning",
        gradient: "linear-gradient(135deg, #f59e0b 0%, #f97316 100%)",
      },
      1003: {
        title: "Xmas Menu Dashboard",
        color: "danger",
        gradient: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
      },
      1004: {
        title: "BeninClub1931",
        color: "danger",
        gradient: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
      },
      1006: {
        title: businessData.name,
        color: "danger",
        gradient: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
      },
      1007: {
        title: businessData.name,
        color: "danger",
        gradient: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
      },
      1009: {
        title: businessData.name,
        color: "danger",
        gradient: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
      },
      1010: {
        title: businessData.name,
        color: "danger",
        gradient: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
      }, 
      1011: {
        title: businessData.name,
        color: "danger",
        gradient: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
      }, 
      1014: {
        title: businessData.name,
        color: "danger",
        gradient: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
      },
      1015: {
        title: businessData.name,
        color: "danger",
        gradient: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
      },
    }
    return configs[businessTypeId] || configs[1004]
  }

  const renderMenuItems = (businessTypeId: number) => {
    const config = getBusinessConfig(businessTypeId)
    const activeMenuValue = getActiveMenuValue()

    return (
      <Box
        sx={{
          background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
          minHeight: "100vh",
          padding: 0,
          width: "100%",
          maxWidth: "100vw",
          overflow: "hidden",
        }}
      >
        {/* Header Section - Mobile Optimized */}
        <Box
          sx={{
            background: config.gradient,
            padding: { xs: "16px 12px", sm: "24px 16px" },
            borderRadius: "0 0 16px 16px",
            marginBottom: "12px",
            boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", mb: { xs: 1, sm: 2 } }}>
            <Avatar
              sx={{
                width: { xs: 36, sm: 48 },
                height: { xs: 36, sm: 48 },
                mr: { xs: 1.5, sm: 2 },
                background: "rgba(255,255,255,0.2)",
                backdropFilter: "blur(10px)",
              }}
            >
              <IonIcon icon={homeSharp} style={{ fontSize: "20px", color: "white" }} />
            </Avatar>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              {Number(getUser().loginData?.roleID) === 9 ? (<Typography
                variant="h6"
                sx={{
                  color: "white",
                  fontWeight: "bold",
                  fontSize: { xs: "0.9rem", sm: "1.1rem" },
                  lineHeight: 1.2,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                Merchant Dashboard
              </Typography>
              ) : (
                <Typography
                  variant="h6"
                  sx={{
                    color: "white",
                    fontWeight: "bold",
                    fontSize: { xs: "0.9rem", sm: "1.1rem" },
                    lineHeight: 1.2,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {config.title}
                </Typography>)}
              {businessData && (
                <Typography
                  variant="body2"
                  sx={{
                    color: "rgba(255,255,255,0.9)",
                    fontSize: { xs: "0.75rem", sm: "0.85rem" },
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  Hello {getUser()?.userData.firstName} {getUser()?.userData.lastName}
                </Typography>
              )}
            </Box>
          </Box>

          {/* Role Badge - Mobile Optimized */}
          {(businessTypeId === 1004 || businessTypeId === 1007 || businessTypeId === 1009 || businessTypeId === 1014 || businessTypeId === 1006) && (
            <Box
              sx={{
                background: "rgba(255,255,255,0.2)",
                backdropFilter: "blur(10px)",
                borderRadius: "8px",
                padding: { xs: "6px 12px", sm: "8px 16px" },
                display: "flex",
                alignItems: "center",
                maxWidth: "fit-content",
              }}
            >
              <IonIcon
                icon={personCircle}
                style={{
                  fontSize: "16px",
                  color: "white",
                  marginRight: "6px",
                }}
              />
              <Typography
                variant="body2"
                sx={{
                  color: "white",
                  fontWeight: "600",
                  fontSize: { xs: "0.75rem", sm: "0.85rem" },
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {getUser()?.roleName}
              </Typography>
            </Box>
          )}
        </Box>

        {/* Menu Items - Mobile Optimized */}
        <IonList
          style={{
            background: "transparent",
            padding: "0 8px",
            margin: 0,
          }}
        >
          <IonAccordionGroup
            value={activeMenuValue}
            style={{
              background: "transparent",
            }}
          >
            {menuList?.map((appPage: AppPage, index: number) => {
              const isActive = isMenuActive(appPage)
              return (
                <Box
                  key={index}
                  sx={{
                    mb: 1,
                    borderRadius: "12px",
                    overflow: "hidden",
                    background: "rgba(255,255,255,0.9)",
                    backdropFilter: "blur(10px)",
                    boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
                    border: "1px solid rgba(255,255,255,0.2)",
                  }}
                >
                  <IonAccordion value={appPage.name}>
                    <IonItem
                      slot="header"
                      lines="none"
                      style={{
                        "--background": "transparent",
                        "--color": "#1e293b",
                        "--padding-start": "12px",
                        "--padding-end": "12px",
                        "--min-height": "52px",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          width: "100%",
                          minWidth: 0,
                        }}
                      >
                        <Box
                          sx={{
                            width: { xs: 32, sm: 40 },
                            height: { xs: 32, sm: 40 },
                            borderRadius: "8px",
                            background: iconColors[index % iconColors.length],
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            mr: { xs: 1.5, sm: 2 },
                            flexShrink: 0,
                          }}
                        >
                          <IonIcon
                            icon={personCircle}
                            style={{
                              fontSize: "16px",
                              color: "white",
                            }}
                          />
                        </Box>
                        <Typography
                          variant="body1"
                          sx={{
                            fontWeight: "600",
                            color: "#1e293b",
                            fontSize: { xs: "0.85rem", sm: "1rem" },
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            flex: 1,
                          }}
                        >
                          {appPage.name}
                        </Typography>
                      </Box>
                    </IonItem>

                    <Box
                      slot="content"
                      sx={{
                        background: "rgba(248,250,252,0.8)",
                        padding: "6px",
                      }}
                    >
                      {subModule
                        .filter((moduleList) => moduleList.moduleID == appPage.moduleID)
                        .sort((a, b) => a.submoduleID - b.submoduleID)
                        .map((filteredModule, i) => {
                          const isSubActive = isSubMenuActive(filteredModule)
                          return (
                            <IonMenuToggle key={filteredModule.id} autoHide={false}>
                              <IonItem
                                lines="none"
                                className={isSubActive ? "selected" : ""}
                                routerLink={`/folder/${filteredModule.url}/${filteredModule.name}`}
                                routerDirection="none"
                                style={{
                                  "--background": isSubActive
                                    ? "rgba(79, 70, 229, 0.2)"
                                    : "transparent",
                                  "--color": isSubActive ? "#4f46e5" : "#475569",
                                  "--padding-start": "12px",
                                  "--padding-end": "12px",
                                  "--min-height": "44px",
                                  margin: "2px 0",
                                  borderRadius: "8px",
                                  border: isSubActive
                                    ? "2px solid rgba(79, 70, 229, 0.3)"
                                    : "none",
                                  transition: "all 0.2s ease",
                                }}
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "100%",
                                    minWidth: 0,
                                  }}
                                >
                                  <Box
                                    sx={{
                                      width: { xs: 24, sm: 32 },
                                      height: { xs: 24, sm: 32 },
                                      borderRadius: "6px",
                                      background: isSubActive
                                        ? "rgba(79, 70, 229, 0.3)"
                                        : "rgba(99, 102, 241, 0.1)",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      mr: { xs: 1.5, sm: 2 },
                                      flexShrink: 0,
                                    }}
                                  >
                                    <IonIcon
                                      icon={returnDownForward}
                                      style={{
                                        fontSize: "12px",
                                        color: isSubActive ? "#4f46e5" : "#6366f1",
                                      }}
                                    />
                                  </Box>
                                  <Typography
                                    variant="body2"
                                    sx={{
                                      fontWeight: isSubActive ? "700" : "500",
                                      color: isSubActive ? "#4f46e5" : "#475569",
                                      fontSize: { xs: "0.8rem", sm: "0.9rem" },
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                      flex: 1,
                                    }}
                                  >
                                    {filteredModule.name}
                                  </Typography>
                                </Box>
                              </IonItem>
                            </IonMenuToggle>
                          )
                        })}
                    </Box>
                  </IonAccordion>
                </Box>
              )
            })}
          </IonAccordionGroup>

          {/* Additional Menu Items - Mobile Optimized */}
          <Box sx={{ mt: 1, px: 0 }}>
            {/* Profile Item */}
            {(businessTypeId === 1004 || businessTypeId === 1006 || businessTypeId === 1007 || businessTypeId === 1009 || businessTypeId === 1014) && (
              <IonMenuToggle autoHide={false}>
                <IonItem
                  lines="none"
                  routerLink="/folder/profile"
                  className={location.pathname.includes('profile') ? "selected" : ""}
                  style={{
                    "--background": location.pathname.includes('profile')
                      ? "rgba(109, 40, 217, 0.2)"
                      : "rgba(255,255,255,0.9)",
                    "--color": location.pathname.includes('profile') ? "#6d28d9" : "#1e293b",
                    "--padding-start": "12px",
                    "--padding-end": "12px",
                    "--min-height": "48px",
                    borderRadius: "12px",
                    margin: "6px 0",
                    border: location.pathname.includes('profile')
                      ? "2px solid rgba(109, 40, 217, 0.3)"
                      : "none",
                    boxShadow: location.pathname.includes('profile')
                      ? "0 2px 16px rgba(109, 40, 217, 0.2)"
                      : "0 2px 12px rgba(0,0,0,0.06)",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                      minWidth: 0,
                    }}
                  >
                    <Box
                      sx={{
                        width: { xs: 32, sm: 40 },
                        height: { xs: 32, sm: 40 },
                        borderRadius: "8px",
                        background: location.pathname.includes('profile')
                          ? "linear-gradient(135deg, #6d28d9 0%, #5b21b6 100%)"
                          : "linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mr: { xs: 1.5, sm: 2 },
                        flexShrink: 0,
                      }}
                    >
                      <IonIcon
                        icon={personCircle}
                        style={{
                          fontSize: "16px",
                          color: "white",
                        }}
                      />
                    </Box>
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: location.pathname.includes('profile') ? "700" : "600",
                        color: location.pathname.includes('profile') ? "#6d28d9" : "#1e293b",
                        fontSize: { xs: "0.85rem", sm: "1rem" },
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      My Profile
                    </Typography>
                  </Box>
                </IonItem>
              </IonMenuToggle>
            )}

            {/* Switch Business Item */}
            {(Number(getUser().loginData?.roleID) === 2 ||
              Number(getUser().loginData?.roleID) === 3 ||
              Number(getUser().loginData?.roleID) === 4 ||
              Number(getUser().loginData?.roleID) === 5) && (
                <IonMenuToggle autoHide={false}>
                  <IonItem
                    lines="none"
                    routerLink="/folder/staffWelcomePage"
                    className={location.pathname.includes('staffWelcomePage') ? "selected" : ""}
                    style={{
                      "--background": location.pathname.includes('staffWelcomePage')
                        ? "rgba(14, 116, 144, 0.2)"
                        : "rgba(255,255,255,0.9)",
                      "--color": location.pathname.includes('staffWelcomePage') ? "#0e7490" : "#1e293b",
                      "--padding-start": "12px",
                      "--padding-end": "12px",
                      "--min-height": "48px",
                      borderRadius: "12px",
                      margin: "6px 0",
                      border: location.pathname.includes('staffWelcomePage')
                        ? "2px solid rgba(14, 116, 144, 0.3)"
                        : "none",
                      boxShadow: location.pathname.includes('staffWelcomePage')
                        ? "0 2px 16px rgba(14, 116, 144, 0.2)"
                        : "0 2px 12px rgba(0,0,0,0.06)",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        minWidth: 0,
                      }}
                    >
                      <Box
                        sx={{
                          width: { xs: 32, sm: 40 },
                          height: { xs: 32, sm: 40 },
                          borderRadius: "8px",
                          background: location.pathname.includes('staffWelcomePage')
                            ? "linear-gradient(135deg, #0e7490 0%, #155e75 100%)"
                            : "linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          mr: { xs: 1.5, sm: 2 },
                          flexShrink: 0,
                        }}
                      >
                        <IonIcon
                          icon={businessOutline}
                          style={{
                            fontSize: "16px",
                            color: "white",
                          }}
                        />
                      </Box>
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: location.pathname.includes('staffWelcomePage') ? "700" : "600",
                          color: location.pathname.includes('staffWelcomePage') ? "#0e7490" : "#1e293b",
                          fontSize: { xs: "0.85rem", sm: "1rem" },
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Switch Business
                      </Typography>
                    </Box>
                  </IonItem>
                </IonMenuToggle>
              )}

            {/* Merchant Dashboard for Role 9 */}
            {Number(getUser().loginData?.roleID) === 9 && (
              <>
                <IonMenuToggle autoHide={false}>
                  <IonItem
                    lines="none"
                    routerLink="/folder/BusinessPage"
                    className={location.pathname.includes('BusinessPage') ? "selected" : ""}
                    style={{
                      "--background": location.pathname.includes('BusinessPage')
                        ? "rgba(180, 83, 9, 0.2)"
                        : "rgba(255,255,255,0.9)",
                      "--color": location.pathname.includes('BusinessPage') ? "#b45309" : "#1e293b",
                      "--padding-start": "12px",
                      "--padding-end": "12px",
                      "--min-height": "48px",
                      borderRadius: "12px",
                      margin: "6px 0",
                      border: location.pathname.includes('BusinessPage')
                        ? "2px solid rgba(180, 83, 9, 0.3)"
                        : "none",
                      boxShadow: location.pathname.includes('BusinessPage')
                        ? "0 2px 16px rgba(180, 83, 9, 0.2)"
                        : "0 2px 12px rgba(0,0,0,0.06)",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        minWidth: 0,
                      }}
                    >
                      <Box
                        sx={{
                          width: { xs: 32, sm: 40 },
                          height: { xs: 32, sm: 40 },
                          borderRadius: "8px",
                          background: location.pathname.includes('BusinessPage')
                            ? "linear-gradient(135deg, #b45309 0%, #92400e 100%)"
                            : "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          mr: { xs: 1.5, sm: 2 },
                          flexShrink: 0,
                        }}
                      >
                        <IonIcon
                          icon={businessOutline}
                          style={{
                            fontSize: "16px",
                            color: "white",
                          }}
                        />
                      </Box>
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: location.pathname.includes('BusinessPage') ? "700" : "600",
                          color: location.pathname.includes('BusinessPage') ? "#b45309" : "#1e293b",
                          fontSize: { xs: "0.85rem", sm: "1rem" },
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Merchant Dashboard
                      </Typography>
                    </Box>
                  </IonItem>
                </IonMenuToggle>

             

                <IonMenuToggle autoHide={false}>
                  <IonItem
                    lines="none"
                    routerLink="/folder/inappMessages"
                    className={location.pathname.includes('inappMessages') ? "selected" : ""}
                    style={{
                      "--background": location.pathname.includes('inappMessages')
                        ? "rgba(5, 150, 105, 0.2)"
                        : "rgba(255,255,255,0.9)",
                      "--color": location.pathname.includes('inappMessages') ? "#065f46" : "#1e293b",
                      "--padding-start": "12px",
                      "--padding-end": "12px",
                      "--min-height": "48px",
                      borderRadius: "12px",
                      margin: "6px 0",
                      border: location.pathname.includes('inappMessages')
                        ? "2px solid rgba(5, 150, 105, 0.3)"
                        : "none",
                      boxShadow: location.pathname.includes('inappMessages')
                        ? "0 2px 16px rgba(5, 150, 105, 0.2)"
                        : "0 2px 12px rgba(0,0,0,0.06)",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        minWidth: 0,
                      }}
                    >
                      <Box
                        sx={{
                          width: { xs: 32, sm: 40 },
                          height: { xs: 32, sm: 40 },
                          borderRadius: "8px",
                          background: location.pathname.includes('inappMessages')
                            ? "linear-gradient(135deg, #065f46 0%, #064e3b 100%)"
                            : "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          mr: { xs: 1.5, sm: 2 },
                          flexShrink: 0,
                        }}
                      >
                        <IonIcon
                          icon={notificationsOutline}
                          style={{
                            fontSize: "16px",
                            color: "white",
                          }}
                        />
                      </Box>
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: location.pathname.includes('inappMessages') ? "700" : "600",
                          color: location.pathname.includes('inappMessages') ? "#065f46" : "#1e293b",
                          fontSize: { xs: "0.85rem", sm: "1rem" },
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Notification
                      </Typography>
                    </Box>
                  </IonItem>
                </IonMenuToggle>

                <IonMenuToggle autoHide={false}>
                  <IonItem
                    lines="none"
                    routerLink="/folder/profile"
                    className={location.pathname.includes('profile') ? "selected" : ""}
                    style={{
                      "--background": location.pathname.includes('profile')
                        ? "rgba(109, 40, 217, 0.2)"
                        : "rgba(255,255,255,0.9)",
                      "--color": location.pathname.includes('profile') ? "#6d28d9" : "#1e293b",
                      "--padding-start": "12px",
                      "--padding-end": "12px",
                      "--min-height": "48px",
                      borderRadius: "12px",
                      margin: "6px 0",
                      border: location.pathname.includes('profile')
                        ? "2px solid rgba(109, 40, 217, 0.3)"
                        : "none",
                      boxShadow: location.pathname.includes('profile')
                        ? "0 2px 16px rgba(109, 40, 217, 0.2)"
                        : "0 2px 12px rgba(0,0,0,0.06)",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        minWidth: 0,
                      }}
                    >
                      <Box
                        sx={{
                          width: { xs: 32, sm: 40 },
                          height: { xs: 32, sm: 40 },
                          borderRadius: "8px",
                          background: location.pathname.includes('profile')
                            ? "linear-gradient(135deg, #6d28d9 0%, #5b21b6 100%)"
                            : "linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          mr: { xs: 1.5, sm: 2 },
                          flexShrink: 0,
                        }}
                      >
                        <IonIcon
                          icon={personCircle}
                          style={{
                            fontSize: "16px",
                            color: "white",
                          }}
                        />
                      </Box>
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: location.pathname.includes('profile') ? "700" : "600",
                          color: location.pathname.includes('profile') ? "#6d28d9" : "#1e293b",
                          fontSize: { xs: "0.85rem", sm: "1rem" },
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        My Profile
                      </Typography>
                    </Box>
                  </IonItem>
                </IonMenuToggle>
              </>
            )}

            {/* Logout Item */}
            <IonMenuToggle autoHide={false}>
              <IonItem
                lines="none"
                onClick={hangleLogout}
                button
                style={{
                  "--background": "rgba(185, 28, 28, 0.1)",
                  "--color": "#991b1b",
                  "--padding-start": "12px",
                  "--padding-end": "12px",
                  "--min-height": "48px",
                  borderRadius: "12px",
                  margin: "6px 0",
                  border: "2px solid rgba(185, 28, 28, 0.2)",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    minWidth: 0,
                  }}
                >
                  <Box
                    sx={{
                      width: { xs: 32, sm: 40 },
                      height: { xs: 32, sm: 40 },
                      borderRadius: "8px",
                      background: "linear-gradient(135deg, #dc2626 0%, #991b1b 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mr: { xs: 1.5, sm: 2 },
                      flexShrink: 0,
                    }}
                  >
                    <IonIcon
                      icon={exitOutline}
                      style={{
                        fontSize: "16px",
                        color: "white",
                      }}
                    />
                  </Box>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: "700",
                      color: "#991b1b",
                      fontSize: { xs: "0.85rem", sm: "1rem" },
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Logout
                  </Typography>
                </Box>
              </IonItem>
            </IonMenuToggle>
          </Box>
        </IonList>

        {/* Bottom Actions - Mobile Optimized */}
        <Box sx={{ p: { xs: 1.5, sm: 2 }, mt: 1 }}>
          <Button
            variant="contained"
            onClick={handleEnableNotifications}
            fullWidth
            sx={{
              borderRadius: "12px",
              py: { xs: 1.2, sm: 1.5 },
              fontWeight: "600",
              fontSize: { xs: "0.85rem", sm: "1rem" },
              background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
              boxShadow: "0 4px 20px rgba(99, 102, 241, 0.3)",
              "&:hover": {
                background: "linear-gradient(135deg, #5b5bd6 0%, #7c3aed 100%)",
                transform: "translateY(-1px)",
                boxShadow: "0 6px 25px rgba(99, 102, 241, 0.4)",
              },
              transition: "all 0.3s ease",
            }}
          >
            Enable Notifications
          </Button>

             {/* <IonMenuToggle autoHide={false}>
                  <IonItem
                    lines="none"
                    routerLink="/folder/housekeeping/Housekeeping Assignment"
                    className={location.pathname.includes('BusinessPage') ? "selected" : ""}
                    style={{
                      "--background": location.pathname.includes('BusinessPage')
                        ? "rgba(180, 83, 9, 0.2)"
                        : "rgba(255,255,255,0.9)",
                      "--color": location.pathname.includes('BusinessPage') ? "#b45309" : "#1e293b",
                      "--padding-start": "12px",
                      "--padding-end": "12px",
                      "--min-height": "48px",
                      borderRadius: "12px",
                      margin: "6px 0",
                      border: location.pathname.includes('BusinessPage')
                        ? "2px solid rgba(180, 83, 9, 0.3)"
                        : "none",
                      boxShadow: location.pathname.includes('BusinessPage')
                        ? "0 2px 16px rgba(180, 83, 9, 0.2)"
                        : "0 2px 12px rgba(0,0,0,0.06)",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        minWidth: 0,
                      }}
                    >
                      <Box
                        sx={{
                          width: { xs: 32, sm: 40 },
                          height: { xs: 32, sm: 40 },
                          borderRadius: "8px",
                          background: location.pathname.includes('BusinessPage')
                            ? "linear-gradient(135deg, #b45309 0%, #92400e 100%)"
                            : "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          mr: { xs: 1.5, sm: 2 },
                          flexShrink: 0,
                        }}
                      >
                        <IonIcon
                          icon={businessOutline}
                          style={{
                            fontSize: "16px",
                            color: "white",
                          }}
                        />
                      </Box>
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: location.pathname.includes('BusinessPage') ? "700" : "600",
                          color: location.pathname.includes('BusinessPage') ? "#b45309" : "#1e293b",
                          fontSize: { xs: "0.85rem", sm: "1rem" },
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Housekeeping Assignment
                      </Typography>
                    </Box>
                  </IonItem>
                </IonMenuToggle> */}
                  {/* <IonMenuToggle autoHide={false}>
                  <IonItem
                    lines="none"
                    routerLink="/folder/bulk_housekeeping/Housekeeping Assignment"
                    className={location.pathname.includes('BusinessPage') ? "selected" : ""}
                    style={{
                      "--background": location.pathname.includes('BusinessPage')
                        ? "rgba(180, 83, 9, 0.2)"
                        : "rgba(255,255,255,0.9)",
                      "--color": location.pathname.includes('BusinessPage') ? "#b45309" : "#1e293b",
                      "--padding-start": "12px",
                      "--padding-end": "12px",
                      "--min-height": "48px",
                      borderRadius: "12px",
                      margin: "6px 0",
                      border: location.pathname.includes('BusinessPage')
                        ? "2px solid rgba(180, 83, 9, 0.3)"
                        : "none",
                      boxShadow: location.pathname.includes('BusinessPage')
                        ? "0 2px 16px rgba(180, 83, 9, 0.2)"
                        : "0 2px 12px rgba(0,0,0,0.06)",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        minWidth: 0,
                      }}
                    >
                      <Box
                        sx={{
                          width: { xs: 32, sm: 40 },
                          height: { xs: 32, sm: 40 },
                          borderRadius: "8px",
                          background: location.pathname.includes('BusinessPage')
                            ? "linear-gradient(135deg, #b45309 0%, #92400e 100%)"
                            : "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          mr: { xs: 1.5, sm: 2 },
                          flexShrink: 0,
                        }}
                      >
                        <IonIcon
                          icon={businessOutline}
                          style={{
                            fontSize: "16px",
                            color: "white",
                          }}
                        />
                      </Box>
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: location.pathname.includes('BusinessPage') ? "700" : "600",
                          color: location.pathname.includes('BusinessPage') ? "#b45309" : "#1e293b",
                          fontSize: { xs: "0.85rem", sm: "1rem" },
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Housekeeping Assignment 
                      </Typography>
                    </Box>
                  </IonItem>
                </IonMenuToggle>

                <IonMenuToggle autoHide={false}>
                  <IonItem
                    lines="none"
                    routerLink="/folder/registerlost_found/Register Lost"
                    className={location.pathname.includes('BusinessPage') ? "selected" : ""}
                    style={{
                      "--background": location.pathname.includes('BusinessPage')
                        ? "rgba(180, 83, 9, 0.2)"
                        : "rgba(255,255,255,0.9)",
                      "--color": location.pathname.includes('BusinessPage') ? "#b45309" : "#1e293b",
                      "--padding-start": "12px",
                      "--padding-end": "12px",
                      "--min-height": "48px",
                      borderRadius: "12px",
                      margin: "6px 0",
                      border: location.pathname.includes('BusinessPage')
                        ? "2px solid rgba(180, 83, 9, 0.3)"
                        : "none",
                      boxShadow: location.pathname.includes('BusinessPage')
                        ? "0 2px 16px rgba(180, 83, 9, 0.2)"
                        : "0 2px 12px rgba(0,0,0,0.06)",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        minWidth: 0,
                      }}
                    >
                      <Box
                        sx={{
                          width: { xs: 32, sm: 40 },
                          height: { xs: 32, sm: 40 },
                          borderRadius: "8px",
                          background: location.pathname.includes('BusinessPage')
                            ? "linear-gradient(135deg, #b45309 0%, #92400e 100%)"
                            : "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          mr: { xs: 1.5, sm: 2 },
                          flexShrink: 0,
                        }}
                      >
                        <IonIcon
                          icon={businessOutline}
                          style={{
                            fontSize: "16px",
                            color: "white",
                          }}
                        />
                      </Box>
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: location.pathname.includes('BusinessPage') ? "700" : "600",
                          color: location.pathname.includes('BusinessPage') ? "#b45309" : "#1e293b",
                          fontSize: { xs: "0.85rem", sm: "1rem" },
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Register Lost & Found 
                      </Typography>
                    </Box>
                  </IonItem>
                </IonMenuToggle>

                <IonMenuToggle autoHide={false}>
                  <IonItem
                    lines="none"
                    routerLink="/folder/viewlost_found/View Lost"
                    className={location.pathname.includes('BusinessPage') ? "selected" : ""}
                    style={{
                      "--background": location.pathname.includes('BusinessPage')
                        ? "rgba(180, 83, 9, 0.2)"
                        : "rgba(255,255,255,0.9)",
                      "--color": location.pathname.includes('BusinessPage') ? "#b45309" : "#1e293b",
                      "--padding-start": "12px",
                      "--padding-end": "12px",
                      "--min-height": "48px",
                      borderRadius: "12px",
                      margin: "6px 0",
                      border: location.pathname.includes('BusinessPage')
                        ? "2px solid rgba(180, 83, 9, 0.3)"
                        : "none",
                      boxShadow: location.pathname.includes('BusinessPage')
                        ? "0 2px 16px rgba(180, 83, 9, 0.2)"
                        : "0 2px 12px rgba(0,0,0,0.06)",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        minWidth: 0,
                      }}
                    >
                      <Box
                        sx={{
                          width: { xs: 32, sm: 40 },
                          height: { xs: 32, sm: 40 },
                          borderRadius: "8px",
                          background: location.pathname.includes('BusinessPage')
                            ? "linear-gradient(135deg, #b45309 0%, #92400e 100%)"
                            : "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          mr: { xs: 1.5, sm: 2 },
                          flexShrink: 0,
                        }}
                      >
                        <IonIcon
                          icon={businessOutline}
                          style={{
                            fontSize: "16px",
                            color: "white",
                          }}
                        />
                      </Box>
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: location.pathname.includes('BusinessPage') ? "700" : "600",
                          color: location.pathname.includes('BusinessPage') ? "#b45309" : "#1e293b",
                          fontSize: { xs: "0.85rem", sm: "1rem" },
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        View Lost & Found 
                      </Typography>
                    </Box>
                  </IonItem>
                </IonMenuToggle>

                <IonMenuToggle autoHide={false}>
                  <IonItem
                    lines="none"
                    routerLink="/folder/assignment/Assignment Report"
                    className={location.pathname.includes('BusinessPage') ? "selected" : ""}
                    style={{
                      "--background": location.pathname.includes('BusinessPage')
                        ? "rgba(180, 83, 9, 0.2)"
                        : "rgba(255,255,255,0.9)",
                      "--color": location.pathname.includes('BusinessPage') ? "#b45309" : "#1e293b",
                      "--padding-start": "12px",
                      "--padding-end": "12px",
                      "--min-height": "48px",
                      borderRadius: "12px",
                      margin: "6px 0",
                      border: location.pathname.includes('BusinessPage')
                        ? "2px solid rgba(180, 83, 9, 0.3)"
                        : "none",
                      boxShadow: location.pathname.includes('BusinessPage')
                        ? "0 2px 16px rgba(180, 83, 9, 0.2)"
                        : "0 2px 12px rgba(0,0,0,0.06)",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        minWidth: 0,
                      }}
                    >
                      <Box
                        sx={{
                          width: { xs: 32, sm: 40 },
                          height: { xs: 32, sm: 40 },
                          borderRadius: "8px",
                          background: location.pathname.includes('BusinessPage')
                            ? "linear-gradient(135deg, #b45309 0%, #92400e 100%)"
                            : "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          mr: { xs: 1.5, sm: 2 },
                          flexShrink: 0,
                        }}
                      >
                        <IonIcon
                          icon={businessOutline}
                          style={{
                            fontSize: "16px",
                            color: "white",
                          }}
                        />
                      </Box>
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: location.pathname.includes('BusinessPage') ? "700" : "600",
                          color: location.pathname.includes('BusinessPage') ? "#b45309" : "#1e293b",
                          fontSize: { xs: "0.85rem", sm: "1rem" },
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Assignment Report
                      </Typography>
                    </Box>
                  </IonItem>
                </IonMenuToggle>

                <IonMenuToggle autoHide={false}>
                  <IonItem
                    lines="none"
                    routerLink="/folder/roomstatusreport/Room Report"
                    className={location.pathname.includes('BusinessPage') ? "selected" : ""}
                    style={{
                      "--background": location.pathname.includes('BusinessPage')
                        ? "rgba(180, 83, 9, 0.2)"
                        : "rgba(255,255,255,0.9)",
                      "--color": location.pathname.includes('BusinessPage') ? "#b45309" : "#1e293b",
                      "--padding-start": "12px",
                      "--padding-end": "12px",
                      "--min-height": "48px",
                      borderRadius: "12px",
                      margin: "6px 0",
                      border: location.pathname.includes('BusinessPage')
                        ? "2px solid rgba(180, 83, 9, 0.3)"
                        : "none",
                      boxShadow: location.pathname.includes('BusinessPage')
                        ? "0 2px 16px rgba(180, 83, 9, 0.2)"
                        : "0 2px 12px rgba(0,0,0,0.06)",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        minWidth: 0,
                      }}
                    >
                      <Box
                        sx={{
                          width: { xs: 32, sm: 40 },
                          height: { xs: 32, sm: 40 },
                          borderRadius: "8px",
                          background: location.pathname.includes('BusinessPage')
                            ? "linear-gradient(135deg, #b45309 0%, #92400e 100%)"
                            : "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          mr: { xs: 1.5, sm: 2 },
                          flexShrink: 0,
                        }}
                      >
                        <IonIcon
                          icon={businessOutline}
                          style={{
                            fontSize: "16px",
                            color: "white",
                          }}
                        />
                      </Box>
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: location.pathname.includes('BusinessPage') ? "700" : "600",
                          color: location.pathname.includes('BusinessPage') ? "#b45309" : "#1e293b",
                          fontSize: { xs: "0.85rem", sm: "1rem" },
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Room Status Report
                      </Typography>
                    </Box>
                  </IonItem>
                </IonMenuToggle> */}
        </Box>
      </Box>
    )
  }

  return (
    <IonMenu contentId="main" type="overlay" className="pullUpmenu">
      <IonContent className="ion-no-padding">
        {/* Removed outer IonMenuToggle that was wrapping all items */}
        {Number(businessData.business_type_id) === 1001 && renderMenuItems(1001)}
        {Number(businessData.business_type_id) === 1002 && renderMenuItems(1002)}
        {Number(businessData.business_type_id) === 1003 && renderMenuItems(1003)}
        {Number(businessData.business_type_id) === 1004 && renderMenuItems(1004)}
        {Number(businessData.business_type_id) === 1006 && renderMenuItems(1006)}
        {Number(businessData.business_type_id) === 1007 && renderMenuItems(1007)}
        {Number(businessData.business_type_id) === 1009 && renderMenuItems(1009)}
        {Number(businessData.business_type_id) === 1010 && renderMenuItems(1010)}
        {Number(businessData.business_type_id) === 1011 && renderMenuItems(1011)}
        {Number(businessData.business_type_id) === 1014 && renderMenuItems(1014)}
        {Number(businessData.business_type_id) === 1015 && renderMenuItems(1015)}
        {businessData.business_type_id === undefined && renderMenuItems(1)}
      </IonContent>
    </IonMenu>
  )
}

// MenuButton component remains unchanged
export const MenuButton: React.FC = () => {
  return (
    <IonButtons slot="start">
      <IonMenuToggle>
        <IonButton>
          <IonIcon slot="icon-only" icon={menuOutline} />
        </IonButton>
      </IonMenuToggle>
    </IonButtons>
  )
}

export default Menu
